profads.ads2['aggressiveDriverExt'] = function(e) {
  if (typeof e !== 'object') {
    return;
  }
  const that = this;
  const isMobile = PageMetadata.reqHeaders.device == 'MOBILE';
  function getAdLabelText(text){
    if (!text) return 'Information from Industry';
    switch(text.toLowerCase()) {
      case 'ifi':
      case 'information from industry':
        return 'Information from Industry';
      case 'gov':
      case 'ifg':
      case 'information from government':
        return 'Information from Government';
      case 'ad':
      case 'advertisement':
        return 'Advertisement';
      case 'none':
      case 'blank':
        return '';
      default:
        return 'Information from Industry';
    }  
  }
  function addQueryString(src) {
    let uri = src,
      key = "icd",
      value = "layer-llr",
      re = new RegExp("([?&])" + key + "=.*?(&|$)", "i"),
      separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
      return (uri.replace(re, '$1' + key + "=" + value + '$2'));
    } else {
      return (uri + separator + key + "=" + value);
    }
  }
  function getEnvironment() {
    let env = PageMetadata.reqHeaders.requestEnv;
    return env == "" ? "" : `.${env}`;
  }
  function loadCSS() {
    let css = that.utils.createElement({
      name: 'link',
      attributes: [
        { rel: 'stylesheet' },
        { href: `//img${that.utils.getEnvironment()}.medscapestatic.com/medscape-core/ads/css/ag-driver.css` },
        { type: 'text/css' },
        { media: 'screen' }
      ]
    });
    that.utils.appendExternalNode(css, document.head);
    return css;
  }
  function closeHandlerLLR(e, animation) {
    let defaultAnimation = {
      props: { opacity: 100 },
      delay: 0,
      complete() {
        document.addEventListener("DOMContentLoaded", function () {wmdPageLink(`${config.productType}_close`, e.target)});
        $(container).remove();
        container.removeEventListener('click', closeHandlerLLR);
        if (isMobile && config.productType == 'layer-cpc' || 
          config.productType == 'layer-optinem' || 
          (config.productType == 'layer-cpc' && config.version === "2025")) {
            document.body.classList.remove('noscroll');
        }
        if (whiteoutLayer && whiteoutLayer.style) {
          whiteoutLayer.style.display = 'none';
        }
      }
    };
    let aniObject = Object.assign(defaultAnimation, animation);
    $(container).delay(aniObject.delay).animate(aniObject.props, aniObject.complete);
  }

  // check for multiple event calls, close previously rendered layer
  if (that.agg_driverRendered === undefined) {
    loadCSS();
  } else {
    closeHandlerLLR({ target: $(`.${agDrvClassName}`).find('.close')[0] });
  }

  const defaults = {
    productType: '',
    adLabelText: 'Information from Industry',
    closeButton: {
      class: 'close-x-image close',
      text: ''
    },
    logo: 1
  };
  let config = Object.assign(defaults, e.detail == undefined ? e : e.detail);
  const appendCue = [];
  const handlerCue = [];
  const globalCampaign = config.globalCampaign && config.globalCampaign.toLowerCase();
  let agDrvClassName = 'aggressive-driver',
    logoClassName = 'agd-logo',
    adLabelClassName = config.adLabelText == undefined ? '' : (config.adLabelText === '' ? 'no-label' : 'llr-adlabel'),
    agIframeID = 'aggressive-driver-frame',
    _zIndex = 1999999,
    whiteoutLayer = document.getElementById('whiteoutlayer');

  if (whiteoutLayer === null) {
    $("body").append("<div id='whiteoutlayer'></div>");
    whiteoutLayer = document.getElementById('whiteoutlayer');
  }

  if (config.productType == 'LLR') {
    agDrvClassName += ` agd-llr`;
  } else if (config.productType == 'layer-cpc') {
    adLabelClassName = adLabelClassName.replace('llr-adlabel', ' agd-cpc cpc-adlabel');
    whiteoutLayer.style.zIndex = 1999995;
    if (globalCampaign == 'true') {
      agDrvClassName += ` agd-cpc global-cpc`;
    } else {
      agDrvClassName += ` agd-cpc`;
    }
    config.adLabelText = getAdLabelText(config?.adLabelText);

    // version 2025 specific styles and functionality
    if (config.version === "2025") {
      agDrvClassName += ` version-2025`;
      config.closeButton = {
        class: 'close-x-image close',
        text: ''
      };

      config.adLabelText = getAdLabelText(config?.newAdLabelText);

      // Add whiteout layer for 2025 version
      document.body.classList.add('noscroll');
      whiteoutLayer.classList.add('version-2025');
    }

    try {
      profads.ads2.updatePIMC();
    } catch (e) {
      console.warn("Error occured in updating PIMC")
    }
  } else if (config.productType == 'layer-optinem') agDrvClassName += ' agd-opt-in';

  // use as wrapper template
  let wrapperObj = {
    name: 'a',
    attributes: [ { href: (config.productType == 'layer-cpc' && config.funded == 't') ? that.utils.checkQueryString(config.href, config.adpos) : config.href }, { target: '_blank' } ]
  };
  let llr_children = [
    {
      name: 'span',
      className: adLabelClassName,
      text: config.adLabelText
    },
    {
      name: 'span',
      className: config.closeButton.class,
      text: config.closeButton.text
    }
  ];

  if (config.logo == 1) {
    llr_children.unshift({
      name: 'img',
      className: logoClassName,
      attributes: [
        { width: '75' },
        { height: '17' },
        { src: 'https://img.medscapestatic.com/pi/logos/mscp-logo.png' }
      ]
    });
  } else {
    agDrvClassName += ` no-logo`;
    llr_children.unshift({
      name: 'span',
      className: 'logoSpacer'
    });
  }
  if (isMobile || config.productType == 'layer-optinem') {
    document.body.classList.add('noscroll');
    whiteoutLayer.style.display = 'block';
  }

  // only add iframe if product type is LLR
  if (config.productType == 'LLR') {
    llr_children.push({
      id: agIframeID,
      name: 'iframe',
      attributes: [
        { src: addQueryString(config.frameSrc) },
        { allowfullscreen: true },
      ]
    });
    handlerCue.push({
      selector: `#${agIframeID}`,
      event: 'load',
      handler() {$(container).addClass('show-llr')}
    });
    try {
      profads.ads2.updatePIMC();
    } catch (e) {
      console.warn("Error occured in updating PIMC");
    }
  } else if (config.productType == 'layer-cpc') {
    delete(llr_children[0].className);

    let logo = {
      name: 'a',
      children: [ llr_children.shift() ],
      className: logoClassName,
      attributes: [ { href: (config.funded == 't' ? (that.utils.checkQueryString("https://www.medscape.com", config.adpos)) : 'https://www.medscape.com') }, { target: '_blank' } ]
    };
    
    // For version 2025, create header wrapper
    if (config.version === "2025") {
      let headerDiv = {
        name: 'div',
        className: 'top-header',
        children: [
          logo,
          llr_children[0], // ad label
          llr_children[1]  // close button
        ]
      };

      // Replace first two elements with header div
      llr_children.splice(0, 2, headerDiv);
    } else {
      // For non-2025 versions, keep original structure
      llr_children.unshift(logo);
    }
    
    
    let cpcHeadline = Object.assign({
      className: 'cpc-headline',
      children: [ {
        name: 'h3',
        renderHTML: true,
        text: config.headline
      } ]
    }, wrapperObj);
    let cpcBody = Object.assign({
      className: `cpc-body ${config.graphicTextToggle ? config.graphicTextToggle.toLowerCase() : ''}`,
      children: [ {
        name: 'p',
        renderHTML: true,
        text: config.body
      } ]
    }, wrapperObj);
    let cpcCTA = {
      name: 'div',
      className: `cta-wrapper cta-${config.graphicTextToggle ? config.graphicTextToggle.toLowerCase() : ''}`,
      children: [ {
        name: 'a',
        className: 'cpc-cta',
        renderHTML: true,
        text: config.cta,
        attributes: [ { href: (config.funded == 't') ? that.utils.checkQueryString(config.href, config.adpos) : config.href }, { target: '_blank' } ]
      } ]
    };
    let cpcJobCode = {
      name: 'span',
      className: 'job-code',
      renderHTML: true,
      text: config.jobCode || ''
    };
    let cpcNodes = [ cpcHeadline, cpcBody, cpcCTA ];

    if (config.reference) {
      let cpcRef = {
        name: 'span',
        className: 'cpc-ref',
        text: config.reference,
        renderHTML: true
      };
      cpcNodes.push(cpcRef);
    }

    if (globalCampaign == "true") {
      if (config.promoDisclaimer) {
        let promoDisclaimer = {
          name: 'span',
          className: 'promo-disclaimer',
          renderHTML: true,
          text: config.promoDisclaimer
        }
        cpcNodes.push(promoDisclaimer);
      }
      if (config.aer.toLowerCase() == 'true' && config.aerText != '') {
        let aerDiv = {
          name: 'div',
          className: 'aer',
          children: [ {
            name: 'span',
            className: 'aer-text',
            renderHTML: true,
            text: config.aerText
          } ]
        }
        cpcNodes.push(aerDiv);
      }
    }

    if (config.additionalLink) {
      cpcJobCode.className += ' no-flex';
      let cpcLinks = {
        name: 'div',
        className: globalCampaign == 'true' ? 'cpc-links-global' : 'cpc-links',
        children: []
      };
      let tempLinks = [];
      const [ link1, link2, ...others ] = config.additionalLink;
      if (globalCampaign == 'false') {
        tempLinks.splice(0, 0, link1, link2);
      } else {
        tempLinks.splice(0, 0, link1, ...others);
      }
      tempLinks.forEach((x, i) => {
        let _linkClass = `cpc-link omni-link-${i}`;
        let mlink;
        if (globalCampaign == 'true') {
          mlink = 'pilink';
        } else {
          mlink = i === 0 ? 'pilink' : 'medguide';
        }
        let linkText = x.linkTxt;
        let extLink = x.href;
        let _omniData = {
          "mlink": `${mlink}-${config.activityId}`,
          "textLink": linkText,
          "extLink": extLink,
          "mmodule": 'nativeconnect'
        }
        cpcLinks.children.push({
          name: 'a',
          className: _linkClass,
          renderHTML: true,
          text: x.linkTxt,
          attributes: [ { href: (config.funded == 't' && x.href.length > 1) ? that.utils.checkQueryString(x.href, config.adpos) : x.href }, { target: '_blank' } ],
        });
        // Add omniture call for native Driver only
        if(config.funded === 'f'){
          handlerCue.push({
            selector: `.${_linkClass.split(' ').join('.')}`,
            event: 'click',
            handler: that.postOmnitureData.bind(null, _omniData)});
        }
      });
      cpcNodes.push(cpcLinks);
    }
    cpcNodes.push(cpcJobCode);
    cpcNodes.forEach(x => { llr_children.push(x)});

    [ '.cta-wrapper a', '.cpc-headline', '.cpc-body' ].forEach(cl => {
      handlerCue.push({
        selector: cl,
        event: 'click',
        handler: profads.ads2.postCpData.bind(profads.ads2, {
          appname: 'tracker',
          activityName: 'click',
          impr: [ {
            tcid: config.tcid,
            activityId: config.activityId,
            ver: 2,
            pos: config.adpos,
            exp: 0,
            branded: 2,
            msgCategory: 7,
            adType: 8
          } ]
        })
      });
    });

  } else if (config.productType == 'layer-optinem') {
    whiteoutLayer.style.display = 'block';
    whiteoutLayer.style.backgroundColor = '#000';
    whiteoutLayer.style.opacity = '0.65';
    llr_children.splice(0, 2);

    const templates = {
      content: `<h3 class="opt-in-title">${config.optInTitle}</h3>
        <p class="opt-in-body">${config.optInBody}</p>
        <section class="opt-in-cards">
            <div class="card front">
                <a class="cta">${config.cta}</a>
            </div>
            <div class="card back">
                <span class="response-icon"><img src="https://img.medscapestatic.com/pi/univadis/opt-in/icon-signed-up-2x.png" width="42" height="43" alt="icon signed up"/></span>
                <h3 class="response-title">${config.successTitle}</h3>
                <p class="response-body">${config.successBody}</p>
            </div>
        </section>`
    };
    const contentDiv = that.utils.createElement({
      name: 'div',
      className: 'opt-in-content'
    });
    const sidebarDiv = that.utils.createElement({
      name: 'div',
      className: 'opt-in-sidebar'
    });

    contentDiv.innerHTML = templates.content;
    appendCue.push(sidebarDiv, contentDiv);

    // attach dom handlers after container has been appended to body
    handlerCue.push({
      selector: '.opt-in-cards .cta',
      event: 'click',
      handler: callAPI
    });

    function callAPI(e) {
      $.ajax({
        type: "GET",
        url: `https://api${that.utils.getEnvironment()}.medscape.com/regservice/registration/pub/v2/saveoptins?guid=418042242&level=all`,
        dataType: "json",
        timeout: 2000,
        error(xhr, status, error) {
          document.querySelector('.response-title').textContent = config.failureTitle;
          document.querySelector('.response-body').textContent = config.failureBody;
          document.querySelector('.response-icon').classList.add('error');
        },
        success(response, status, xhr) {
          if (xhr.status === 200) {
            document.querySelector('.response-title').textContent = config.successTitle;
            document.querySelector('.response-body').textContent = config.successBody;
            that.postCpData({
              'tacticId': config.cpdata.tacticId,
              'appname': config.cpdata.appname,
              'activityName': config.cpdata.activityName,
              'activityId': config.cpdata.activityId
            });
            closeHandlerLLR({ target: document.querySelector('.aggressive-driver .close') }, { delay: 5000 });
          }
        },
        complete() {
          $('.opt-in-cards').toggleClass('flipped');
          container.classList.add('submitted')
        }
      });
    }
  } // end opt-in layer

  handlerCue.push({
    selector: `.aggressive-driver .${config.closeButton.class.split(' ')[0]}`,
    event: 'click',
    handler: closeHandlerLLR
  });

  var container = that.utils.createElement({
    name: 'div',
    className: agDrvClassName,
    children: llr_children
  });
  appendCue.forEach((x) => {
    container.appendChild(x);
  });

  document.body.appendChild(container);
  handlerCue.forEach((x) => {
    let ele = document.querySelector(x.selector);
    if (ele) ele.addEventListener(x.event, x.handler, x.capture || false);
  });

  container.style.zIndex = _zIndex;

  that.agg_driverRendered = true;
}
